import React, { useState } from 'react';
import GiftCard from './GiftCard';
import classNames from 'classnames';

const MonthlyPackage = ({ currency }) => {
  const [active, setActive] = useState(false);
  return (
    <div className="bg-[#F5F5F5]">
      <div className="container flex flex-col justify-center items-center h-full">
        <h2
          className={
            'flex max-w-[650px] md:text-center justify-center items-center w-full font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black py-[48px] px-[8px]'
          }
        >
          See what kind of value is included on your monthly package
        </h2>
        <GiftCard active={active} onClick={setActive} currency={currency} />
        <div
          className={classNames(
            ' flex justify-center max-w-[940px] pt-[32px] pb-[48px] gap-[5px] transition-opacity',
            !active ? 'opacity-0' : 'opacity-100'
          )}
        >
          <span className="icon icon-info-yellow w-[16px] min-w-[16px] h-[16px] inline-block" />
          <p className="text-[12px] leading-[15px] font-[300]">
            <i>
              {' '}
              Each of the tools our full-service digital marketing agency uses in our SEO processes is a premium paid tool designed to leverage your
              online presence, ensuring guaranteed SEO results. By partnering with us, you are guaranteed access to these elite resources in their
              entirety, and all at no extra cost to you, assured of getting the maximum ROI ever and digital performance that is second to none.
            </i>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MonthlyPackage;
